// document.addEventListener("turbo:load", () => {
//   const restrictionSelect = document.getElementById("category_restriction_select");
//   if (!restrictionSelect) return;

//   console.log("Load: spurimpact/category_restriction.js")

//   const sections = {
//     org_category: document.getElementById("org_category"),
//     org_category_type: document.getElementById("org_category_type"),
//     org_super_category: document.getElementById("org_super_category")
//   };

//   const allSections = Object.values(sections).filter(Boolean);

//   const hideAll = () => {
//     allSections.forEach(section => {
//       section.classList.add("d-none");

//       section
//         .querySelectorAll(".restricted-category-select")
//         .forEach(select => {
//           select.required = false;
//         });
//     });
//   };

//   const showSection = (key) => {
//     const section = sections[key];
//     if (!section) return;

//     section.classList.remove("d-none");

//     section
//       .querySelectorAll(".restricted-category-select")
//       .forEach(select => {
//         select.required = true;
//       });
//   };

//   const updateVisibility = () => {
//     hideAll();

//     const value = restrictionSelect.value;
//     if (!value || value === "unrestricted") return;

//     showSection(value);
//   };

//   // Initial render (edit / validation rerender)
//   updateVisibility();

//   // User changes
//   restrictionSelect.addEventListener("change", updateVisibility);
// });

// document.addEventListener("turbo:load", () => {
//   const restrictionSelect =
//     document.getElementById("category_restriction_select");

//   if (!restrictionSelect){

//      return;
//   }

//   console.log("Load: spurimpact/category_restriction.js")

//   const sections = {
//     org_category: document.getElementById("org_category"),
//     org_category_type: document.getElementById("org_category_type"),
//     org_super_category: document.getElementById("org_super_category")
//   };

//   const allSections = Object.values(sections).filter(Boolean);

//   const hideAll = () => {
//     allSections.forEach(section => {
//       section.classList.add("d-none");
//       section
//         .querySelectorAll(".restricted-category-select")
//         .forEach(select => select.required = false);
//     });
//   };

//   const showSection = (id) => {
//     const section = sections[id];
//     if (!section) return;

//     section.classList.remove("d-none");
//     section
//       .querySelectorAll(".restricted-category-select")
//       .forEach(select => select.required = true);
//   };

//   const updateVisibility = () => {
//     hideAll();

//     const value = restrictionSelect.value;
//     if (!value || value === "none") return;

//     showSection(value);
//   };

//   updateVisibility();
//   restrictionSelect.addEventListener("change", updateVisibility);
// });

document.addEventListener("turbo:load", () => {
  const restrictionSelect =
    document.querySelector('select[name$="[category_restriction]"]');

  if (!restrictionSelect) return;

  const sections = {
    org_category: document.getElementById("org_category"),
    org_category_type: document.getElementById("org_category_type"),
    org_super_category: document.getElementById("org_super_category")
  };

  const allSections = Object.values(sections).filter(Boolean);

  const hideAll = () => {
    allSections.forEach(section => {
      section.classList.add("d-none");

      section
        .querySelectorAll(".restricted-category-select")
        .forEach(select => {
          select.required = false;
          select.disabled = true;   // ← THIS is critical
        });
    });
  };

  const showSection = (id) => {
    const section = sections[id];
    if (!section) return;

    section.classList.remove("d-none");

    section
      .querySelectorAll(".restricted-category-select")
      .forEach(select => {
        select.required = true;
        select.disabled = false;   // ← only ONE enabled
      });
  };

  const updateVisibility = () => {
    hideAll();

    const value = restrictionSelect.value;
    if (!value || value === "none") return;

    showSection(value);
  };

  updateVisibility();
  restrictionSelect.addEventListener("change", updateVisibility);
});